import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import Header from "../../component/header/Header";
import Aside from "../../component/aside/Aside";
import Footer from "../../component/footer/Footer2";

import "./TierHistory.scss";

const TIERS = ["Silver", "Gold", "Platinum", "Exclusive"];

const TIER_SECTIONS = [
  {
    sectionTitle: "",
    rows: [
      {
        label: "Annual Spend",
        values: [
          "₹0 – ₹1,00,000",
          "₹1,00,000 – ₹3,00,000",
          "₹3,00,000 – ₹5,00,000",
          "₹5,00,000+",
        ],
      },
      {
        label: "Reward % on Purchase Value",
        values: ["2%", "3%", "5%", "7%"],
      },
      {
        label: "Joining Bonus",
        values: ["100 Points", "100 Points", "100 Points", "100 Points"],
      },
      {
        label: "Birthday Bonus",
        values: ["100 Points", "300 Points", "500 Points", "1000 Points"],
      },
      {
        label: "Parking Benefit",
        values: [
          "",
          "4 free parkings quarterly(1 in each mall)",
          "2 free parkings quarterly(2 in each mall)",
          "1 free parking monthly(1 in each mall)",
        ],
      },
    ],
  },
];

const TierHistory = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("v-pills-home");

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
    >
      Home
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#1D1D1B",
      }}
    >
      Tier Benefits
    </Typography>,
  ];

  const breadcrumbsMobile = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#A9A9A9",
      }}
    >
      Home
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#ffffff",
      }}
    >
      Tier Benefits
    </Typography>,
  ];

  return (
    <>
      <Header activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="home">
        <div
          className="container pt-5 in-mobile desktop_content"
          style={{ paddingBottom: "40px" }}
        >
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </div>
        <div className="sidebar">
          <div className="container">
            <div className="row">
              <div className="col-lg-4  col-md-4 desktop_content">
                <Aside activeTab={activeTab} setActiveTab={setActiveTab} />
              </div>
              <div className="col-lg-8 col-md-8 in-mobile">
                <div className="tabs">
                  <div className="tab_content">
                    <div className="tab-content" id="v-pills-tabContent">
                      <div
                        className=""
                        id="v-pills-tier-history"
                        role="tabpanel"
                        aria-labelledby="v-pills-tier-history-tab"
                        tabIndex="0"
                      >
                        <div className="tier-history">
                          <div className="title-container">
                            <div className="container pt-5 in-mobile mobile_content">
                              <Breadcrumbs
                                separator={
                                  <NavigateNextIcon
                                    fontSize="small"
                                    sx={{ color: "#A9A9A9" }}
                                  />
                                }
                                aria-label="breadcrumb"
                              >
                                {breadcrumbsMobile}
                              </Breadcrumbs>
                            </div>
                            <h2>Tier Benefits</h2>
                          </div>

                          <div className="tier-table-wrapper">
                            <table className="tier-table">
                              <thead>
                                <tr>
                                  <th className="benefits-col">Benefits</th>
                                  {TIERS.map((tier, idx) => (
                                    <th
                                      key={tier}
                                      className={`tier-col tier-${idx + 1}`}
                                    >
                                      {tier}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {TIER_SECTIONS.map((section) => (
                                  <React.Fragment key={section.sectionTitle}>
                                    {section.sectionTitle ? (
                                      <tr className="section-row">
                                        <td
                                          className="section-title"
                                          colSpan={5}
                                        >
                                          {section.sectionTitle}
                                        </td>
                                      </tr>
                                    ) : null}
                                    {section.rows.map((row, idx) => (
                                      <tr
                                        key={`${section.sectionTitle}-${idx}`}
                                      >
                                        <td className="row-label">
                                          {row.label}
                                        </td>
                                        {row.values.map((val, i) => {
                                          return (
                                            <td
                                              key={`${section.sectionTitle}-${idx}-${i}`}
                                              className={`row-value col-${
                                                i + 2
                                              }`}
                                            >
                                              {val}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    ))}
                                  </React.Fragment>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footerMobPending"></div>
      <Footer selected="tier-history" />
    </>
  );
};

export default TierHistory;
